import React, { lazy } from "react";
import { Formik, Field, Form } from "formik"
import l from "components/util/l";
import { MultiField } from "seed/helpers";
import { UpgradePlanMessage } from "components/util/helpers/PlanMessages";


const FlowEditFormView = ({
  initialValues = {},
  userUsage,
  flow,
  flows,
  folders,
  isEditing = false,
  historyRouter,
  templateCategories,
  isDeveloper,
  onSubmit,
  onClickDelete = () => { },
}) => (
  <div className="card">

    <div class="card-header">
      <h3 class="card-header-title">
        {isEditing ? l("Editar solución%SB034") : l("Crear solución%SB033")}
      </h3>
    </div>

    <div className="card-body px-4">
      <Formik
        initialValues={initialValues}
        onSubmit={onSubmit}
      >
        {({ values, setFieldValue }) =>
          <Form>

            {/* Name */}
            <div class="form-group mb-4">
              <label class="input-label" for="name">{l("Nombre de la solución%SB002")} <span className='text-danger'>*</span></label>
              <Field type="text" name="name" id="name" autocomplete="off"
                class="form-control form-control" maxlength="512"
                placeholder={l("Ej. Prospección de clientes%SB003")}
                required autoFocus={true} />
            </div>

            <div class="form-group mb-4">
              <label class="input-label" for="folder">{l("Carpeta%SB004")}</label>
              <Field as="select" name="folder" id="folder"
                class="form-control form-control" required
                onChange={(e) => {
                  const val = e.target.value
                  if (val == "create") historyRouter.push("/create_folder")
                  else setFieldValue("folder", val)
                }}>
                <option value="0">{l("Sin carpeta%SB005")}</option>
                {folders.map((folder) => (
                  <option key={folder.id} value={folder.id}>{folder.name}</option>
                ))}
                <option value="create">+ {l("Crear carpeta%SB006")}</option>
              </Field>
            </div>

            {isDeveloper &&
              <div class="form-group mb-4">
                <span
                  class="text-primary"
                  data-toggle="collapse"
                  href="#flow-developer-settings"
                  role="button"
                  aria-expanded="false"
                  aria-controls="flow-developer-settings"
                >
                  {l("Opciones de desarrollador%SB007")} <i className="fas fa-angle-down"/>
                </span>
              </div>}

            {isDeveloper && (
              <div className="collapse px-1" id="flow-developer-settings">

                <div class="form-group mb-4">
                  <div class="custom-control custom-checkbox">
                    <Field type="checkbox" name="is_template" id="is_template"
                      class="custom-control-input" />
                    <label class="custom-control-label" for="is_template">
                      {l("Modo plantilla%SB009")}
                    </label>
                  </div>
                </div>

                {values.is_template &&
                  <div className="ml-7 mb-6">
                    <div class="form-group mb-3">
                      <label class="input-label" for="template_name">{l("Nombre de plantilla%SB010")}</label>
                      <Field type="text" name="template_name" id="template_name"
                        class="form-control form-control" maxlength="512" />
                    </div>

                    {/* Description */}
                    <div class="form-group mb-4">
                      <label class="input-label" for="name">{l("Descripción%GA077")} <span style={{ fontSize: "0.75rem", color: "#a0a5b0" }}>({l("Opcional%GA024")})</span></label>
                      <textarea
                        name="description"
                        id="description"
                        class="form-control form-control"
                        value={values.description}
                        maxlength="1024"
                        onChange={(e) => setFieldValue("description", e.target.value)}
                      />
                    </div>


                    <div class="form-group">
                      <label class="input-label mb-1" for="template_categories">
                        {l("Categorías de plantilla%SB011")}
                      </label>

                      <MultiField
                        name="template_categories"
                        value={values?.template_categories ?? []}
                        values={templateCategories.map(category => ({
                          value: category.id,
                          label: category.uiSettings?.display?.title
                        }))
                        }
                        setFieldValue={setFieldValue}
                      />
                    </div>

                    <div class="form-group">
                      <label class="input-label" for="template_type">{l("Tipo de plantilla%SB013")}</label>
                      <Field as="select" name="template_type" id="template_type"
                        class="form-control form-control" required>
                        <option value="USE_CASE">{l("Caso de uso%SB014")}</option>
                        <option value="SAMPLE">Sample</option>
                      </Field>
                    </div>

                    <div class="form-group">
                      <label class="input-label" for="template_settings">{l("Relevancia%SB055")}</label>
                      <Field type="number" name="template_settings.relevance" id="template_settings.relevance"
                        class="form-control form-control" value={values?.template_settings?.relevance ?? 0} min="0" max="100" />
                    </div>
                  </div>
                }

                <div class="form-group mb-4">
                  <label class="input-label" for="owner">{l("Usuario propietario (user_id)%SB008")}</label>
                  <Field type="text" name="owner" id="owner" class="form-control form-control" required />
                </div>


                <div class="form-group mb-4">
                  <label class="input-label" for="folder">{l("Proceso padre%SB049")}</label>
                  <Field
                    as="select"
                    name="parent_id"
                    id="parent_id"
                    class="form-control form-control"
                    required
                  >
                    <option value="0">{l("Sin padre%SB050")}</option>
                    {flows.map((f) => (
                      f.id != flow?.id &&
                      <option key={f.id} value={f.id}>{f.name}</option>
                    ))}
                  </Field>
                </div>



              </div>
            )}

            {
              function(){
                return <>
                  {
                    (userUsage.flows.percentage != 100 || isEditing) &&
                      <div className="row">
                        <div className={`col-md-${(isEditing) ? "9 pr-md-0" : "12"} mb-2 mb-md-0`}>
                          <button 
                            type="submit" 
                            class="btn btn-block btn-primary font-weight-bold"
                          >
                            {!isEditing ? l("Crear solución%SB033") : l("Guardar%GA023")}
                          </button>
                        </div>
                        {(isEditing) && (
                          <div className="col-md-3">
                            <button type="button" class="btn btn-block btn-outline-danger" onClick={onClickDelete}>
                              {l("Eliminar%GA001")}
                            </button>
                          </div>
                        )}
                      </div>
                  }
                </>;
              }()
            }

          </Form>}
      </Formik>
    </div>
  </div>
);

export default FlowEditFormView;